import { Link, useLocation } from 'react-router-dom';
// import { useState } from 'react';
import { useSelector } from 'react-redux';

import { useMediaPredicate } from 'react-media-hook';
import { MOBILE_SIZE } from 'utils/mediaQueryUtils';
import { isAdminUser } from 'utils/userUtils';

import './DashboardNav.css';

const AdminNav = ({ onChangeNav }) => {
	const location = useLocation();
	const pathname = location.pathname;
	const isMobile = useMediaPredicate(MOBILE_SIZE);
	const userData = useSelector((state) => state.user.userData);
	// const [isCollapsed, setIsCollapsed] = useState(isMobile);
	const isCollapsed = isMobile;

	const isActive = (navItem) => {
		return pathname === navItem.url;
	};

	const navItems = [
		{
			label: 'Portfolios',
			url: '/admin/portfolios',
			key: 'portfolios',
			icon: 'bi bi-building',
		},
		{
			label: 'Top Violations',
			url: '/admin/top-violations',
			key: 'topViolations',
			icon: 'bi bi-graph-up',
		},
		{
			label: 'Users',
			url: '/admin/users',
			key: 'users',
			icon: 'bi bi-people',
		},
		{
			label: 'Subscriptions',
			url: '/admin/subscriptions',
			key: 'subscriptions',
			icon: 'bi bi-credit-card',
		},
		{
			label: 'Alerts & Notifications',
			url: '/admin/notifications',
			key: 'notifications',
			icon: 'bi bi-bell',
		},
		{
			label: 'Email Tracking',
			url: '/admin/email-tracking',
			key: 'emailTracking',
			icon: 'bi bi-envelope',
		},
		{
			label: 'SMS Responses',
			url: '/admin/sms-responses',
			key: 'smsResponses',
			icon: 'bi bi-chat-dots',
		},
		{
			label: 'Street View Reports',
			url: '/admin/street-view-reports',
			key: 'streetViewReports',
			icon: 'bi bi-camera',
		},
		{
			label: 'Queue Monitor',
			url: '/admin/queue-monitor',
			key: 'queueMonitor',
			icon: 'bi bi-list-check',
			// The queue monitor API is admin-gated (jwt.auth + admin);
			// non-admins must not see a nav entry to a broken page.
			adminOnly: true,
		},
		{
			label: 'Dataset Monitor',
			url: '/admin/dataset-monitor',
			key: 'datasetMonitor',
			icon: 'bi bi-database-check',
			// API is admin-gated; non-admins must not see a link to a broken page.
			adminOnly: true,
		},
		{
			label: 'Files',
			url: '/admin/files',
			key: 'files',
			icon: 'bi bi-file-earmark-ruled',
		},
	];

	const visibleNavItems = navItems.filter(
		(item) => !item.adminOnly || isAdminUser(userData),
	);

	// let titleText = "Dashboard";

	// navItems.forEach(item => {
	// 	if (isActive(item)) {
	// 		titleText = item.label;
	// 	}
	// })

	return (
		<div
			className={`rd-dashboard-nav rd-admin-nav ${isCollapsed ? 'rd-dashboard-collapsed' : ''}`}
		>
			{/*!isCollapsed && <div className="rd-dashboard-nav-title">{titleText}</div>*/}
			<div className="rd-dashboard-nav-content">
				<div className="rd-dashboard-nav-list">
					{visibleNavItems.map((item) => (
						<div
							key={item.key}
							className={`rd-dashboard-nav-item ${isActive(item) ? 'is-active' : ''}`}
						>
							<Link to={item.url} className="rd-dashboard-nav-link">
								<span className="rd-dashboard-nav-icon">
									<i className={item.icon} />
								</span>
								{!isCollapsed && (
									<span className="rd-dashboard-nav-label">{item.label}</span>
								)}
							</Link>
						</div>
					))}
				</div>
				<div className="dashboard-nav-collapse-button-wrapper" />
				{/*					{!isMobile && (
						<button className="btn btn-link dashboard-nav-collapse-button" onClick={toggleCollapse}>
							{isCollapsed ? <i className="be bi-caret-right-fill" /> : <i className="be bi-caret-left-fill" />}
						</button>
					)}
				</div>*/}
			</div>
		</div>
	);
};

export default AdminNav;
